<!-- 字库首页 -->
<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ path: '/academic_Management/academic_font_management/academic_font_management_home' }">学术词库系统</el-breadcrumb-item>
            <el-breadcrumb-item>赛事类词库</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">SPBCN比赛词库</span>
                </el-col>
            </el-row>
            <!--  -->
            <el-row :gutter="15">
                <el-col :span="4">
                    <div class="panel" @click="nextFn">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-11.jpg" alt="">
                        <div class="title">第11赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-10.jpg" alt="">
                        <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第10赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-9.jpg" alt="">
                         <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第9赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-8.jpg" alt="">
                        <div class="title">第8赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-7.jpg" alt="">
                        <div class="title">第7赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-6.jpg" alt="">
                        <div class="title">第6赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-5.jpg" alt="">
                        <div class="title">第5赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-4.jpg" alt="">
                        <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第4赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-3.jpg" alt="">
                         <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第3赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-2.jpg" alt="">
                         <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第2赛季</div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="panel">
                        <img class="cover" src="https://cdn.spbcn.org/spbcnappneed/ciku-cover-1.jpg" alt="">
                         <!-- <div class="cover-div">
                            <i class="el-icon-collection"></i>
                        </div> -->
                        <div class="title">第1赛季</div>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <el-card style="margin-top: 15px;">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">洲际挑战赛词库</span>
                </el-col>
            </el-row>
            <el-empty description="暂未上传" :image-size="80"></el-empty>
        </el-card>
    </div>
</template>
<script>

export default {
  data () {
    return {
      //
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    nextFn () {
      this.$router.push('/academic_Management/academic_font_management/academic_wordgroup_management')
    }
  }
}
</script>
<style scoped lang="less">
.menu-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .menu-item {
        margin-right: 16px;
        flex: 1;
        color: #fff;
        font-size: 18px;
        cursor: pointer;
    }
}
.table-row {
    display: flex;
    align-items: center;
    height: 40px;
    span {
        display: block;
        width: 80px;
        margin-right: 20px;
    }
}
.table-row1 {
    height: 40px;
    line-height: 40px;
}

.tag {
    height: 32px;
    line-height: 32px;
    border-radius: 32px;
    background-image: linear-gradient(to right, #409eff 40%, #95c5f4);
    color: #fff;
    font-size: 14px;
    padding-left: 42px;
    padding-right: 20px;
    position: relative;
    margin-top: 20px;
    margin-bottom: 10px;
    cursor: pointer;
    .tag-icon {
        width: 34px;
        height: 34px;
        border-radius: 34px;
        background-color: #409eff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #fff;
        position: absolute;
        left: -2px;
        top: -2px;
        .iconfont {
            font-size: 20px;
        }
    }
}
.tag-define {
    background: transparent;
    border: 2px solid #37b9f6;
    color: #37b9f6;
    height: 28px;
    line-height: 28px;
    .tag-icon {
        color: #fff;
        border-color: #37b9f6;
        top: -4px;
    }
}
.cover{
    width: 150px;
    height: 200px;
    object-fit: contain;
}
.cover-div{
    width: 150px;
    height: 200px;
    margin: 0 auto;
    background-color: #D9ECFF;
    color: #fff;
    font-size: 30px;
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    padding-top: 6px;
}
.title{
    margin: 10px auto;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #000;
    background-color: #C7E2FF;
    padding: 4px 10px;
    border-radius: 6px;
    width: 150px;
}
.panel{
    // background-color: #D9ECFF;
    border-radius: 10px;
    padding: 14px 0;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
}
</style>
